$(function() {
  $('.clear-cart').on('click',function(e){
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        location.reload();
      },
      dataType: 'json'
    });
  })
});

$('.collectionSlider').slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
$('.featuredCollection-slider').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

var collectionListHeader = parseInt(parseInt($('.collectionList .btn-2').outerHeight() - 20) / 2);

$('.collectionSlider .slick-arrow').css('bottom', collectionListHeader);


  function myFunction(x) {
  if (x.matches) { // If media query matches
   $('.topBar-right').hide();
  } else {
   $('.topBar-right').show();
  }
}

var x = window.matchMedia("(max-width: 720px)");
myFunction(x);// Call listener function at run time
x.addListener(myFunction);


$('.hideMob-search').on('click',function(){
   $('.hideDesk-search').click();
})


